import React from "react";
import type { Language } from "../../context/LanguageContext";

interface LanguageSelectorProps {
  language: Language;
  onSelect: (language: Language) => void;
}

const CostaRicaFlag = () => (
  <svg viewBox="0 0 30 20" className="h-4 w-6 rounded-sm shadow-sm" aria-hidden="true">
    <rect width="30" height="20" fill="#002b7f" />
    <rect y="3" width="30" height="14" fill="#fff" />
    <rect y="6" width="30" height="8" fill="#ce1126" />
  </svg>
);

const UnitedStatesFlag = () => (
  <svg viewBox="0 0 38 20" className="h-4 w-7 rounded-sm shadow-sm" aria-hidden="true">
    <rect width="38" height="20" fill="#fff" />
    {[0, 4, 8, 12, 16].map((y) => <rect key={y} y={y} width="38" height="2" fill="#b22234" />)}
    <rect width="16" height="10.8" fill="#3c3b6e" />
    {[2, 5, 8].map((y) =>
      [2, 5, 8, 11, 14].map((x) => <circle key={`${x}-${y}`} cx={x} cy={y} r="0.55" fill="#fff" />)
    )}
  </svg>
);

const options: { language: Language; Flag: React.FC; label: string; title: string }[] = [
  { language: "es", Flag: CostaRicaFlag, label: "Español", title: "Español" },
  { language: "en", Flag: UnitedStatesFlag, label: "English", title: "English" },
];

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ language, onSelect }) => (
  <div className="flex w-fit items-center gap-0.5 rounded-full border border-border bg-surface p-0.5 shadow-ui-card" aria-label="Language selector">
    {options.map((option) => {
      const active = language === option.language;
      const Flag = option.Flag;

      return (
        <button
          key={option.language}
          type="button"
          aria-label={option.label}
          aria-pressed={active}
          title={option.title}
          onClick={() => onSelect(option.language)}
          className={`relative flex h-9 min-w-11 items-center justify-center rounded-full border px-2 transition-[background-color,border-color,box-shadow] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
            active ? "border-primary/25 bg-primary/10 shadow-sm" : "border-transparent hover:bg-accent"
          }`}
        >
          <Flag />
          {active && <span className="absolute bottom-0.5 h-1 w-1 rounded-full bg-primary" aria-hidden="true" />}
        </button>
      );
    })}
  </div>
);

export default LanguageSelector;
